import {gsap, SplitText, ScrollTrigger} from "../LibrariesImport";
export default class AnimationText {
	static init() {

		this.textes = document.querySelectorAll('.text-animation');
		this.textes.forEach((txt) => {

			const innerSplit = new SplitText(txt, {
				type: "lines, words, chars",
				linesClass: "line",
				charsClass: "char",
				wordsClass: "word",
				tag: "span"
			});

			ScrollTrigger.batch(txt, {
				onEnter: (elements, triggers) => {
					txt.classList.add('appeared');
				}
			});

			ScrollTrigger.batch(innerSplit.lines, {
				onEnter: (elements, triggers) => {
					elements.forEach( (el) => {
						gsap.to(el.querySelectorAll('.char'), {
							opacity: 1,
							scale: 1,
							delay: 0.25,
							stagger: 0.05
						});
					});
				}
			});

		});

	}
}